(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-alya-concentration';

  function initSection(section) {
    var items = section.querySelectorAll('[data-preserve-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-preserve-trigger]');
      var panel = item.querySelector('[data-preserve-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
